export const ROUTES = {
  Landing: "/landing",
  Workspace: "/workspace",
  Dashboard: "/dashboard",
  Login: "/auth/login",
  SignUp: "/auth/register",
  ForgotPassword: "/auth/forgot_password",
  OTPVerification: "/auth/verify_otp",
  ResetPassword: "/auth/reset_password",
  WAChat: "/wa_chat",
  ChatTheme: "/chat_appearance",
  WABAConnection: "/integrate_waba",
  WABAPhoneNumbers: "/waba_phone_numbers",
  MessageTemplates: "/message_templates",
  TemplatesLibrary: "/templates_library",
  Tools: "/toolset",
  ToolsLinkGenerator: "/toolset/link_generator",
  ToolsLinks: "/toolset/links",
  ToolsLinksConfig: "/toolset/links/config",
  ToolsWidget: "/toolset/widget",
  ToolsWidgets: "/toolset/widgets",
  ToolsWidgetsConfig: "/toolset/widgets/config",
  Tags: "/badges",
  Media: "/media_library",
  Teams: "/organization_teams",
  TeamsCreate: "/organization_teams/create",
  Agents: "/agents",
  AgentsCreate: "/agents/create",
  AgentsTask: "/agents/task",
  BotFlow: "/automation_builder",
  BuilderBotFlow: "/automation_builder/builder",
  DefaultAction: "/predefined_action",
  DefaultActionWorkingHours: "/predefined_action/working_hours",
  ReplyMaterials: "/response_resources",
  KeywordAction: "/keyword_trigger",
  KeywordActionCreate: "/keyword_trigger/create",
  AICall: "/ai_call_assistant",
  AICallAgents: "/ai_call_assistant/agents",
  AICallAgentsCreate: "/ai_call_assistant/agents/create",
  AICallAgentsEdit: "/ai_call_assistant/agents/edit",
  AICallLogs: "/ai_call_assistant/logs",
  WhatsappForm: "/whatsapp_form",
  WhatsappFormCreate: "/whatsapp_form/create",
  BillingPlans: "/billing_plans",
  MessageCampaigns: "/broadcast_campaigns",
  MessageCampaignsAdd: "/broadcast_campaigns/add",
  Orders: "/order_management",
  OrdersAutoMessage: "/order_management/auto_message",
  Catalogues: "/product_catalogs",
  CataloguesManage: "/product_catalogs/manage",
  CataloguesManageAdd: "/product_catalogs/manage/add",
  CataloguesManageEdit: "/product_catalogs/manage/edit",
  Webhooks: "/event_notifications",
  WebhooksMapTemplate: "/event_notifications/map_template",
  ContactDirectory: "/contact_directory",
  Segments: "/segments",
  Columns: "/data_fields",
  ImportJobs: "/contact_import_logs",
  AIConfig: "/ai_settings",
  IntegrationTools: "/integration_tools",
  Tasks: "/tasks",
  TasksEdit: "/tasks/edit",
  GoogleAccount:"/google_account",
  PaymentGateway: "/payment_gateway",
  PaymentTransactions: "/payment_transactions",
  AppointmentBooking: "/whatsapp_appointment",
  QuickReplies: "/quick_replies",
  FacebookAccount: "/click_whatsapp_ads",
  PipelineBoard:"/pipeline_board",
};

export const EXTERNAL_DASHBOARD_URL = process.env.NEXT_PUBLIC_DASHBOARD_URL || "https://dashboard.rivetai.co.uk/";

export const API_BASE_URL = process.env.NEXT_PUBLIC_API_BASE_URL;

export const PUBLIC_API_URL = process.env.NEXT_PUBLIC_API_URL;

export const ImagePath: string = "/assets/images";
export const ImageBaseUrl = process.env.NEXT_PUBLIC_STORAGE_URL;
